import script from "./ViewADocument.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewADocument.vue?vue&type=script&setup=true&lang=js"

import "./ViewADocument.vue?vue&type=style&index=0&id=4d542d0e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d542d0e"]])

export default __exports__